import React, { useState, useEffect } from 'react';
import { useVersion } from 'react-admin';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import BorderColorOutlinedIcon from '@material-ui/icons/BorderColorOutlined';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import DateRangeIcon from '@material-ui/icons/DateRange';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import { useSnackbar } from 'notistack';

import { api, getListAllAPI, getOneAPI, getUsername } from '../../services';
import { formatPreco, PRIMARY_COLOR } from '../../utils';
import MobillsInput from '../Pages/RelatorioVendaMensal/DateInputMobills';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function saudacao() {
  const hora = new Date().getHours();
  if (hora < 12) return 'Bom dia';
  if (hora < 18) return 'Boa tarde';
  return 'Boa noite';
}

function getColor(valor, meta, maior, isMeta, parametroComparacao, showValue) {
  if (!(isMeta && showValue)) {
    if (maior) {
      /*if (valor < 0)
      return {
        background: '#ffcccc',
        color: '#e60000',
      };
    if (valor < meta)
      return {
        background: 'white',
        color: 'black',
      };
    return {
      background: '#ccffcd',
      color: '#00e604',
    };*/
      if (valor >= meta) {
        return {
          background: '#ccffcd',
          color: '#00e604',
        };
      }
      return {
        background: '#ffcccc',
        color: '#e60000',
      };
    }
    if (valor <= meta) {
      return {
        background: '#ccffcd',
        color: '#00e604',
      };
    }
    return {
      background: '#ffcccc',
      color: '#e60000',
    };
  }
  if (maior) {
    if (valor >= parametroComparacao) {
      return {
        background: '#ccffcd',
        color: '#00e604',
      };
    }
    return {
      background: '#ffcccc',
      color: '#e60000',
    };
  }
  if (valor <= parametroComparacao) {
    return {
      background: '#ccffcd',
      color: '#00e604',
    };
  }
  return {
    background: '#ffcccc',
    color: '#e60000',
  };
}

// Cor do status do indicador (texto e borda escuros para ter contraste).
const COR_OK = { cor: '#2e7d32', fundo: '#e8f5e9' };
const COR_RUIM = { cor: '#c62828', fundo: '#ffebee' };

const CardTotal = ({
  label,
  valor,
  meta,
  isMeta,
  onClick,
  maior = true,
  parametroComparacao,
  showValue,
}) => {
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const { background } = getColor(
    valor,
    meta,
    maior,
    isMeta,
    parametroComparacao,
    showValue,
  );
  // getColor decide se o indicador está bom; só a apresentação mudou.
  const bom = background === '#ccffcd';
  const { cor, fundo } = bom ? COR_OK : COR_RUIM;
  const progresso = Math.max(0, Math.min(100, Number(valor) || 0));
  return (
    <Paper
      variant="outlined"
      onClick={onClick}
      style={{
        // Celular: um cartão por linha.
        flex: celular ? '1 1 100%' : '1 1 220px',
        minWidth: 0,
        padding: celular ? 12 : 16,
        borderLeft: `4px solid ${cor}`,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Box
        display="flex"
        flexDirection={celular ? 'column' : 'row'}
        alignItems={celular ? 'flex-start' : 'stretch'}
        justifyContent="space-between"
        style={{ gap: 8 }}
      >
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
        {isMeta && (
          <Chip
            size="small"
            label={bom ? 'No ritmo' : 'Abaixo do esperado'}
            style={{
              backgroundColor: fundo,
              color: cor,
              fontWeight: 600,
              flexShrink: 0,
            }}
          />
        )}
      </Box>
      {isMeta && showValue && (
        <Typography variant="caption" color="textSecondary" display="block">
          {`Parâmetro de comparação: ${formatPreco(parametroComparacao)}%`}
        </Typography>
      )}
      <Typography
        variant={celular ? 'h6' : 'h5'}
        component="p"
        style={{ fontWeight: 700, color: cor, marginTop: 4 }}
      >
        {valor < 0 ? '-' : `${formatPreco(valor)}%`}
      </Typography>
      {isMeta && (
        <div
          style={{
            height: 6,
            borderRadius: 3,
            marginTop: 8,
            backgroundColor: fundo,
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: `${progresso}%`,
              height: '100%',
              backgroundColor: cor,
            }}
          />
        </div>
      )}
    </Paper>
  );
};

// Grupo de indicadores (uma meta) com título e os cartões em linha.
const GrupoIndicadores = ({ titulo, children }) => {
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const [aberto, setAberto] = useState(true);
  return (
    <Card style={{ borderRadius: 12, marginBottom: celular ? 12 : 16 }}>
      <CardContent style={celular ? { padding: 12 } : undefined}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onClick={() => setAberto(!aberto)}
          style={{ cursor: 'pointer' }}
        >
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            {titulo}
          </Typography>
          <IconButton
            size="small"
            aria-label={aberto ? 'Recolher' : 'Expandir'}
          >
            {aberto ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        <Collapse in={aberto}>
          <Box display="flex" flexWrap="wrap" mt={1.5} style={{ gap: 12 }}>
            {children}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

// Faixa que separa os indicadores por período (mensais, anuais).
const FaixaPeriodo = ({ icone, children }) => {
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  return (
    <Box
      display="flex"
      alignItems="center"
      mb={celular ? 1.5 : 2}
      mt={1}
      px={celular ? 1.5 : 2}
      py={celular ? 0.75 : 1}
      borderRadius={8}
      style={{
        gap: 12,
        backgroundColor: PRIMARY_COLOR,
        color: 'white',
      }}
    >
      {icone}
      <Typography
        variant={celular ? 'subtitle2' : 'subtitle1'}
        style={{
          fontWeight: 700,
          letterSpacing: 1,
          textTransform: 'uppercase',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

const TituloSecao = ({ children, acao }) => {
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  return (
    <Box
      display="flex"
      flexDirection={celular ? 'column' : 'row'}
      alignItems={celular ? 'stretch' : 'center'}
      justifyContent="space-between"
      flexWrap="wrap"
      mt={3}
      mb={2}
      style={{ gap: 8 }}
    >
      <Typography variant="h6" component="h2" style={{ color: PRIMARY_COLOR }}>
        {children}
      </Typography>
      {acao}
    </Box>
  );
};

function getParametroComparacao(mes, ano) {
  const dataHoje = new Date();
  const mesAtual = dataHoje.getMonth();
  const anoAtual = dataHoje.getFullYear();

  if (ano > anoAtual) {
    return 0;
  }
  if (ano < anoAtual) {
    return 100;
  }
  if (mes > mesAtual) {
    return 0;
  }
  if (mes < mesAtual) {
    return 100;
  }
  const hoje = dataHoje.getDate();
  const n = diasNoMes(mesAtual + 1, anoAtual);
  const parametroComparacao = (100 * (hoje - 1)) / n;
  return parametroComparacao;
}

function diasNoMes(mes, ano) {
  const data = new Date(ano, mes, 0);
  return data.getDate();
}

function formatDadosMensalItem(
  title,
  value,
  labelValue,
  diasRestantes,
  showFaltaCompletar,
  maior = true,
  mes,
  ano,
) {
  const faltante = 100 - value < 0 ? 0 : 100 - value;

  const parametroComparacao = getParametroComparacao(mes, ano);
  return {
    label: title,
    kpis: [
      {
        label: 'Meta',
        valor: value,
        meta: labelValue,
        isMeta: true,
        show: true,
        maior,
        parametroComparacao,
        showValue: showFaltaCompletar,
      },
      {
        label: 'Falta para completar',
        valor: value < 0 ? value : faltante,
        meta: labelValue,
        isMeta: false,
        show: showFaltaCompletar,
        maior,
        parametroComparacao,
        showValue: showFaltaCompletar,
      },
      {
        label: 'Média restante',
        valor:
          value < 0 ? value : diasRestantes <= 0 ? 0 : faltante / diasRestantes,
        meta: labelValue,
        isMeta: false,
        show: showFaltaCompletar,
        maior,
        parametroComparacao,
        showValue: showFaltaCompletar,
      },
    ],
  };
}

function formatDadosMensal(dados, mesSelect, anoSelect) {
  const dadosFormatados = [];
  const registro = dados.length > 0 ? dados[0] : null;

  if (!registro) return [];

  const mes = new Date().getMonth();
  const ano = new Date().getFullYear();

  const diaAtual = new Date().getDate();

  const totalDias = diasNoMes(mes + 1, ano);
  const diasRestantes = totalDias - (diaAtual - 1);

  dadosFormatados.push(
    formatDadosMensalItem(
      'Meta de Aumento de Faturamento Bruto',
      registro.meta_faturamento_valor_final,
      registro.meta_faturamento,
      diasRestantes,
      true,
      true,
      mesSelect,
      anoSelect,
    ),
  );

  dadosFormatados.push(
    formatDadosMensalItem(
      'Meta de Diminuição de Custo Operacional',
      registro.meta_custo_operacional_valor_final,
      registro.meta_custo_operacional,
      diasRestantes,
      false,
      false,
      mesSelect,
      anoSelect,
    ),
  );

  dadosFormatados.push(
    formatDadosMensalItem(
      'Meta de Lucro Bruto',
      registro.meta_lucro_bruto_valor_final,
      registro.meta_lucro_bruto,
      diasRestantes,
      false,
      true,
      mesSelect,
      anoSelect,
    ),
  );

  dadosFormatados.push(
    formatDadosMensalItem(
      'Meta de Lucro Líquido',
      registro.meta_lucro_liquido_valor_final,
      registro.meta_lucro_liquido,
      diasRestantes,
      false,
      true,
      mesSelect,
      anoSelect,
    ),
  );

  dadosFormatados.push(
    formatDadosMensalItem(
      'Meta de Balanço Final',
      registro.meta_balanco_final_valor_final,
      registro.meta_balanco_final,
      diasRestantes,
      false,
      true,
      mesSelect,
      anoSelect,
    ),
  );

  return dadosFormatados;
}

function formatDadosAnualItem(title, value, labelValue, mesesRestantes) {
  const faltante = 100 - value < 0 ? 0 : 100 - value;
  const dataHoje = new Date();
  const hoje = dataHoje.getDate();
  const n = diasNoMes(dataHoje.getMonth() + 1, dataHoje.getFullYear());
  const parametroComparacao = (100 * (hoje - 1)) / n;
  return {
    label: title,
    kpis: [
      {
        label: 'Progresso',
        valor: value,
        meta: labelValue,
        isMeta: true,
        parametroComparacao,
      },
      {
        label: 'Falta para completar',
        valor: value < 0 ? value : faltante,
        meta: labelValue,
        isMeta: false,
      },
      {
        label: 'Média restante',
        valor:
          value < 0
            ? value
            : mesesRestantes <= 0
            ? 0
            : faltante / mesesRestantes,
        meta: labelValue,
        isMeta: false,
      },
    ],
  };
}

function formatDadosAnual(dados) {
  const dadosFormatados = [];
  const registro = dados.length > 0 ? dados[0] : null;

  if (!registro) return [];

  const mes = new Date().getMonth();

  const totalMeses = 12;
  const mesesRestantes = totalMeses - mes;

  dadosFormatados.push(
    formatDadosAnualItem(
      'Meta de Aumento de Faturamento Bruto',
      registro.meta_faturamento_valor_final,
      registro.meta_faturamento,
      mesesRestantes,
    ),
  );

  return dadosFormatados;
}

// Tipos de pendência, com as mesmas cores da tela Minhas pendências.
const TIPOS_PENDENCIA = {
  assinar: {
    rotulo: 'Para assinar',
    cor: '#8a4600',
    fundo: '#fff4e5',
    Icone: BorderColorOutlinedIcon,
  },
  enviar_arquivo: {
    rotulo: 'Para enviar arquivo',
    cor: '#01579b',
    fundo: '#e5f6fd',
    Icone: CloudUploadOutlinedIcon,
  },
  visualizar: {
    rotulo: 'Para ler',
    cor: '#6a1b9a',
    fundo: '#f3e5f5',
    Icone: MenuBookOutlinedIcon,
  },
};

const formatarCompetenciaCard = (c) =>
  c && /^\d{4}-\d{2}$/.test(c) ? `${c.slice(5)}/${c.slice(0, 4)}` : c;

// Faz a propria consulta; em erro o card nao aparece.
const CardDocumentosPendentes = () => {
  const history = useHistory();
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const [resumo, setResumo] = useState(null);

  useEffect(() => {
    api
      .get('/documentos/resumo')
      .then((response) => setResumo(response.data.data))
      .catch(() => setResumo(null));
  }, []);

  if (!resumo) return null;

  const abrirPendencias = () => history.push('/minhas-pendencias');
  const { itens, total } = resumo;
  const contadores = Object.keys(TIPOS_PENDENCIA).filter(
    (acao) => resumo.por_acao && resumo.por_acao[acao] > 0,
  );
  const outras = total - itens.length;

  return (
    <Card
      style={{
        padding: celular ? 16 : 20,
        borderRadius: 12,
        flex: celular ? '1 1 100%' : '1 1 360px',
        borderLeft: `4px solid ${total > 0 ? '#ed6c02' : '#2e7d32'}`,
        backgroundColor: total > 0 ? '#fffaf3' : undefined,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        style={{ gap: 8 }}
      >
        <DescriptionOutlinedIcon color="action" />
        <Typography variant="h6" component="h2">
          Documentos pendentes
        </Typography>
        {total > 0 && <Chip size="small" color="primary" label={total} />}
        <Box flex={1} />
        {total > 0 && !celular && (
          <Button
            color="primary"
            variant="contained"
            size="small"
            style={{ textTransform: 'none' }}
            onClick={abrirPendencias}
          >
            Resolver agora
          </Button>
        )}
      </Box>

      {total === 0 ? (
        <Box
          display="flex"
          alignItems="center"
          style={{ gap: 8, marginTop: 16, color: '#2e7d32' }}
        >
          <CheckCircleOutlineIcon />
          <Typography variant="body2">
            Você está em dia. Nenhuma pendência no momento.
          </Typography>
        </Box>
      ) : (
        <>
          <Box
            display={celular ? 'none' : 'flex'}
            flexWrap="wrap"
            style={{ gap: 8, marginTop: 16 }}
          >
            {contadores.map((acao) => {
              const { rotulo, cor, fundo, Icone } = TIPOS_PENDENCIA[acao];
              return (
                <Box
                  key={acao}
                  display="flex"
                  alignItems="center"
                  px={1.5}
                  py={1}
                  borderRadius={8}
                  style={{ gap: 8, backgroundColor: fundo, color: cor }}
                >
                  <Icone fontSize="small" />
                  <Typography variant="h6" component="span">
                    {resumo.por_acao[acao]}
                  </Typography>
                  <Typography variant="body2" component="span">
                    {rotulo}
                  </Typography>
                </Box>
              );
            })}
          </Box>

          <List disablePadding style={{ marginTop: 8 }}>
            {itens.map((item) => {
              const { cor, fundo, Icone } =
                TIPOS_PENDENCIA[item.acao] || TIPOS_PENDENCIA.assinar;
              return (
                <ListItem
                  button
                  key={item.id}
                  onClick={abrirPendencias}
                  style={{ gap: 12, paddingLeft: 0, paddingRight: 0 }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      flexShrink: 0,
                      backgroundColor: fundo,
                      color: cor,
                    }}
                  >
                    <Icone fontSize="small" />
                  </Box>
                  <ListItemText
                    primary={item.modelo}
                    primaryTypographyProps={{ style: { fontWeight: 600 } }}
                    secondary={[
                      item.colaborador,
                      item.competencia &&
                        `Competência ${formatarCompetenciaCard(
                          item.competencia,
                        )}`,
                      item.created_at &&
                        `Criado em ${new Date(
                          item.created_at,
                        ).toLocaleDateString('pt-BR')}`,
                    ]
                      .filter(Boolean)
                      .join(' · ')}
                  />
                  <ChevronRightIcon color="action" />
                </ListItem>
              );
            })}
          </List>
          {outras > 0 && (
            <Box display="flex" justifyContent="flex-end" mt={1}>
              <Button
                color="primary"
                size="small"
                style={{ textTransform: 'none' }}
                onClick={abrirPendencias}
              >
                {`Ver todas (${total})`}
              </Button>
            </Box>
          )}
        </>
      )}
    </Card>
  );
};

const Grafico = () => {
  const classes = useStyles();
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const version = useVersion();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState({
    gruposMensal: [],
    gruposAnual: [],
    mes: new Date().getMonth(),
    ano: new Date().getFullYear(),
    mensagem: '',
  });
  const { enqueueSnackbar } = useSnackbar();

  async function handleData({ ano, mes }) {
    setLoading(true);
    try {
      //const dados = await api.get(`/dashboard/kpi/${ano}/${mes}`);
      const data = new Date();
      data.setDate(4);
      data.setFullYear(ano);
      data.setMonth(mes);
      data.setDate(4);

      const dataMensal = await getListAllAPI(
        'dados_mes',
        ['id', 'asc'],
        { mes: data.getMonth(), ano: data.getFullYear() },
        [],
      );

      const dataAnual = await getListAllAPI(
        'dados_ano',
        ['id', 'asc'],
        { ano: data.getFullYear() },
        [],
      );

      const config = await getOneAPI('config', 1, []);

      setDados({
        gruposMensal: formatDadosMensal(dataMensal.data, mes, ano),
        gruposAnual: formatDadosAnual(dataAnual.data),
        mes,
        ano,
        mensagem: config.data.mensagem_tela_inicial,
      });
      setLoading(false);
    } catch (e) {
      setDados({ gruposMensal: [], gruposAnual: [], mes, ano, mensagem: '' });
      setLoading(false);
      enqueueSnackbar(`Erro ao carregar os dados!`, {
        variant: 'error',
      });
    }
  }

  useEffect(() => {
    handleData({ ano: dados.ano, mes: dados.mes });
  }, [version]);

  // No celular o react-admin deixa o conteúdo sem margem lateral: a tela cuida da própria folga.
  return (
    <Box px={celular ? 2 : 0} pb={celular ? 3 : 0}>
      <Box mt={2} mb={3}>
        <Typography
          variant={celular ? 'h6' : 'h5'}
          component="h1"
          style={{ fontWeight: 600 }}
        >
          {saudacao()}
          {getUsername() ? `, ${getUsername()}` : ''}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ textTransform: 'capitalize' }}
        >
          {new Date().toLocaleDateString('pt-BR', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </Typography>
      </Box>

      <Box display="flex" flexWrap="wrap" style={{ gap: 16 }}>
        <Card
          style={{
            padding: celular ? 16 : 20,
            borderRadius: 12,
            flex: celular ? '1 1 100%' : '1 1 360px',
            backgroundColor: `${PRIMARY_COLOR}12`,
            borderLeft: `4px solid ${PRIMARY_COLOR}`,
          }}
        >
          <Box display="flex" alignItems="center" style={{ gap: 12 }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                backgroundColor: PRIMARY_COLOR,
                color: 'white',
              }}
            >
              <ChatBubbleOutlineIcon />
            </Box>
            <Typography variant="h6" component="h2">
              Mensagem do dia
            </Typography>
          </Box>
          <Typography
            variant="body1"
            color={dados.mensagem ? 'textPrimary' : 'textSecondary'}
            style={{ marginTop: 12, whiteSpace: 'pre-wrap' }}
          >
            {dados.mensagem || 'Nenhuma mensagem para hoje.'}
          </Typography>
        </Card>
        <CardDocumentosPendentes />
      </Box>

      <TituloSecao acao={<MobillsInput handleData={handleData} />}>
        Indicadores
      </TituloSecao>

      {dados.gruposMensal.length > 0 && (
        <FaixaPeriodo icone={<CalendarTodayIcon />}>Mensais</FaixaPeriodo>
      )}
      {dados.gruposMensal.map(({ label, kpis }) => (
        <GrupoIndicadores key={label} titulo={label}>
          {kpis.map((item) =>
            item.show ? (
              <CardTotal
                key={item.label}
                label={
                  item.isMeta
                    ? `${item.label} ${item.maior ? '>' : '<'} ${formatPreco(
                        item.meta,
                      )}%`
                    : `${item.label}`
                }
                valor={item.valor}
                meta={item.meta}
                isMeta={item.isMeta}
                maior={item.maior}
                parametroComparacao={item.parametroComparacao}
                showValue={item.showValue}
              />
            ) : null,
          )}
        </GrupoIndicadores>
      ))}

      {dados.gruposAnual.length > 0 && (
        <FaixaPeriodo icone={<DateRangeIcon />}>Anuais</FaixaPeriodo>
      )}
      {dados.gruposAnual.map(({ label, kpis }) => (
        <GrupoIndicadores key={label} titulo={label}>
          {kpis.map((item) => (
            <CardTotal
              key={item.label}
              label={
                item.isMeta
                  ? `${item.label} (${formatPreco(item.meta)}%)`
                  : `${item.label}`
              }
              valor={item.valor}
              meta={item.meta}
              isMeta={item.isMeta}
            />
          ))}
        </GrupoIndicadores>
      ))}
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Grafico;
